<div class="downloads-page">
  <div class="header">
    <div class="title">{{ title }}</div>
  </div>
  <progress-spinner *ngIf="isLoading"></progress-spinner>
  <mat-tab-group class="downloads-tab-group" (selectedTabChange)="onTabChange($event)">
    <mat-tab label="Export PM Flows">
      <div class="images-tab-content">
        <div class="uploade-section">
          <mat-card>
            <div class="section-label">
              Export PM flows allows you to produce a CSV file of configuration information for all
              active PM flows.
            </div>
            <div class="group">
              <div class="file-upload-container" *ngIf="licenses && licenses.data.licenses">
                <button
                  mat-flat-button
                  class="input-btn btn-blue"
                  *ngIf="isTWAMPInitiatorLicensePresent()"
                  [disabled]="
                    lastPMFlowAuditUpdate &&
                    lastPMFlowAuditUpdate.twamp &&
                    lastPMFlowAuditUpdate.twamp.status === 'inprogress'
                  "
                  (click)="auditFlows('twamp')"
                >
                  EXPORT TWAMP FLOWS
                </button>
                <button
                  class="input-btn btn-blue"
                  *ngIf="isY1731LicensePresent()"
                  [disabled]="
                    lastPMFlowAuditUpdate &&
                    lastPMFlowAuditUpdate.y1731 &&
                    lastPMFlowAuditUpdate.y1731.status === 'inprogress'
                  "
                  (click)="auditFlows('y1731')"
                >
                  Export Y.1731 Flows
                </button>
              </div>
            </div>
          </mat-card>
        </div>

        <div class="images-list-wrapper" *ngIf="table && table.columns && table.columns.length > 0">
          <div class="datasource-content" *ngIf="showPMAuditResults" class="content-width-100">
            <mat-card class="agent-data">
              <ng-template #action>
                <ng-container class="headline-action-button">
                  <button
                    [matMenuTriggerFor]="menu"
                    mat-button
                    class="action-button"
                    aria-label="Open menu"
                  >
                    <span
                      class="mat-button-wrapper"
                      matTooltip="Different type of agent can't be upgraded."
                      [matTooltipDisabled]="!isActionsDisabled || isActionsShowable"
                      ><i class="material-icons">more_horiz</i></span
                    >
                  </button>
                  <mat-menu #menu="matMenu">
                    <button
                      class="mat-menu-item-btn"
                      mat-menu-item
                      [disabled]="!isActionsDisabledList"
                      (click)="onActionClick({ label: 'download', data: selectedRowData })"
                    >
                      <span>Download</span>
                    </button>
                    <button
                      class="mat-menu-item-btn"
                      mat-menu-item
                      [disabled]="!isActionsDisabledList"
                      (click)="onActionClick({ label: 'remove', data: selectedRowData })"
                    >
                      <span>Remove</span>
                    </button>
                  </mat-menu>
                </ng-container>
              </ng-template>
              <div class="images-table">
                <viavi-table
                  [tableConfigurations]="table"
                  [isActionEnabled]="isCheckBoxEnabled"
                  [template]="action"
                  (sendRowAction)="onActionClick($event)"
                  [showToolbar]="false"
                ></viavi-table>
              </div>
            </mat-card>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Agent Logs">
      <mat-card
        class="logs-container"
        *ngIf="logsTable && logsTable.columns && logsTable.columns.length > 0; else noData"
      >
        <div class="logs-table">
          <viavi-table
            [tableConfigurations]="logsTable"
            [isActionEnabled]="false"
            (sendRowAction)="onTimestampClick($event)"
            [showToolbar]="true"
          ></viavi-table>
        </div>
      </mat-card>
      <ng-template #noData>
        <div class="nodata-section">
          <p class="no-data">Logs data not available</p>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
